import { GtmSupport } from "@gtm-support/core";
import AnalyticsApiService from "./analyticsApi.service";
import TrackingEventService from "./analytics.service";
let trackingEventService = {
    trackEvent: (_eventName, _payload) => { },
    resetEcommerce: () => { },
    flushStoredEvents: () => { },
};
export function provideAnalyticsService(config, analyticsOptions) {
    if (!config || !config.id.length) {
        // eslint-disable-next-line no-console
        console.error("trackingEventService is not initialized");
    }
    else {
        if (analyticsOptions) {
            const analyticsApiService = new AnalyticsApiService(analyticsOptions);
            const sendEventToAnalyticsApi = (payload) => analyticsApiService.sendEventToAnalyticsApi(payload);
            // LEGACY, delete after modification in GTM
            window.sendEventToAnalyticsApi = sendEventToAnalyticsApi;
            window.gtmFct = { sendEventToAnalyticsApi };
        }
        const gtmSupport = new GtmSupport(config);
        if (config.enabled)
            gtmSupport.enable(); // load gtm script
        trackingEventService = new TrackingEventService(gtmSupport);
    }
    return trackingEventService;
}
export function useAnalyticService() {
    return trackingEventService;
}
//# sourceMappingURL=useAnalyticService.js.map